import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  mainContainer: {
    flexDirection: "row",
    width: "100%",
    /* backgroundColor: "#0B87AB", */
    alignItems: "center",
    padding: 0,
    paddingHorizontal: 20,
    minHeight: 500,
    flex: 1,
  },
  leftColumnContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    margin: 0,
  },
  rightColumnContainer: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    margin: 0,
  },
  cardContainer: {
    width: "90%",
    height: 280,
    flexDirection: "row",
    backgroundColor: "#ABDCEA",
    padding: 8,
    borderRadius: 8,
    alignItems: "center",
    justifyContent: "space-evenly",
    margin: 0,
  },
  cardRightColumnContainer: {
    maxWidth: 420,
    flex: 1,
    flexDirection: "column",
    justifyContent: "flex-start",
    margin: 0,
    padding: 20,
  },
  imageMulher: {
    width: 740,
    height: 500,
    margin: 0,
    opacity: 0.9,
  },
  imageSelo: {
    margin: 0,
    width: 180,
    aspectRatio: 2480 / 3507,
  },
  mainHeaderTxt: {
    fontSize: 40,
    color: "#D7F4FC",
    marginBottom: 20,
    fontWeight: "600",
  },
  titleTxtSelo: {
    fontSize: 28,
    color: "#043569",
  },
  subtitleTxtSelo: {
    fontSize: 18,
    marginBottom: 10,
    color: "#043569",
  },
  descriptionTxtSelo: {
    fontSize: 14,
    marginBottom: 15,
    textAlign: "justify",
  },
  btnSaibaMais: {
    padding: 10,
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#0B87AB",
    marginHorizontal: 5,
  },
  btnComprar: {
    padding: 10,
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#043569",
    marginHorizontal: 5,
  },
  containerRowBtns: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginTop: 10,
  },
  txtBtn: {
    color: "#FFF",
  },

  pickerContainer: {
    marginBottom: 20,
  },
});

export default styles;
